import Button from '@storeblocks/button';
import { externalLink } from 'App/themes/PartnerTheme/partnerTheme.helpers';
import { AgreementCode } from 'Constants/agreementCodes.constants';
import { ProductName } from 'Constants/products.constants';
import React from 'react';
import { getAppText } from 'Utils/text';
import { getBuyHouseContentLink } from './buyHouseContentButton.helpers';

interface BuyHouseContentButtonProps {
  insuranceProduct: ProductName;
  agreementCode: AgreementCode;
  disabled: boolean;
}

export const BuyHouseContentButton = ({
  insuranceProduct,
  agreementCode,
  disabled,
}: BuyHouseContentButtonProps): React.ReactElement => (
  <Button
    as="a"
    href={externalLink(
      `${getBuyHouseContentLink(insuranceProduct, agreementCode)}`,
    )}
    data-trackid={`button-change-address_buy-new_insurance_${insuranceProduct}`}
    disabled={disabled}
    rel="noopener noreferrer"
    variant="outlined"
    color="primary"
    padding="8px 24px 8px 0px"
  >
    {getAppText('changeAddress.button.buyInsurance.label')}
  </Button>
);
